import React, { useState } from 'react';
import styles from './NameInput.module.scss';
import { inject } from 'mobx-react';
import { EDITOR_GROUPS_STORE } from 'store';
import { NameInputProps } from './types';

const NameInput = (props: NameInputProps) => {
  const {
    name,
    onClose,
    [EDITOR_GROUPS_STORE]: { renameGroup }
  } = props;

  const [groupName, setGroupName] = useState(name);

  const handleSubmit = () => {
    renameGroup(name, groupName);
    onClose();
  };

  const handleKeyDown = e => {
    e.key === 'Enter' && handleSubmit();
  };

  return (
    <input
      className={styles.input}
      value={groupName}
      onChange={e => setGroupName(e.target.value)}
      autoFocus
      onBlur={handleSubmit}
      onKeyDown={handleKeyDown}
    />
  );
};

export default inject(EDITOR_GROUPS_STORE)(NameInput);
